<mgl-map
  #map
  class="w-full h-full"
  [style]="'mapbox://styles/mapbox/streets-v9'"
  [zoom]="[9]"
  [center]="[12.496366, 41.902782]"
>
</mgl-map>
